import React from "react";
import Gallery from "./gallery";

const Blog = () => {
  return (
    <>
      <Gallery />
    </>
  );
};

export default Blog;